import { render, staticRenderFns } from "./insurance-plan.vue?vue&type=template&id=050b2cd3&scoped=true&"
import script from "./insurance-plan.vue?vue&type=script&lang=js&"
export * from "./insurance-plan.vue?vue&type=script&lang=js&"
import style0 from "./insurance-plan.vue?vue&type=style&index=0&id=050b2cd3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b2cd3",
  null
  
)

export default component.exports